module.exports = __webpack_public_path__ + "img/清单.4a926ec1.png";